import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Heading from "./Heading";
import { useState } from "react";

export default function ContactUs() {
  const [isChecked, setIsChecked] = useState(true);
  const [isCheck, setIsCheck] = useState(false);
  const navigate = useNavigate();

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    if (!event.target.checked) {
      setIsCheck(false);
    }
  };

  const handleBackButton = (event) => {
    event.preventDefault();
    navigate(-1); // Navigates to the previous page
  };

  const handleCheckboxChange1 = (event) => {
    setIsCheck(event.target.checked);
  };
  return (
    <>
      <Heading />
      <div className="card m-3">
        <div
          className="card-header bg-white text-black"
          style={{ fontSize: "25px" }}
        >
          <b>Contact Us</b>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm-5 mb-3" style={{ fontSize: "20px" }}>
              <b>Query Type</b>
            </div>
            <div className="col-sm-7" style={{ fontSize: "20px" }}>
              <b>How to Contact?</b>
            </div>
            <hr />
            <div className="col-sm-5 mt-2" style={{ fontSize: "18px" }}>
              Any issue
            </div>
            <div className="col-sm-7 mt-2" style={{ fontSize: "18px" }}>
              In case of any issue, you can reach us at:
              <br />
              Email - SR5-hpsc@hry.gov.in
              <br />
              OR 
              <br/>
              <a href="http://grievance.onlineapplications.co.in" className="text-decoration-none"> Click here to submit your Issue/Query </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="d-flex justify-content-center"
        style={{ marginBottom: 100 }}
      >
        <button
          className="btn btn-success text-white"
          onClick={handleBackButton}
        >
          Back
        </button>
      </div>
      <Footer />
    </>
  );
}
